export const DEFAULT_EDITOR_BACKGROUND = '#f7f7f7';
export const APPAREL_EDITOR_BACKGROUND = '#e4e4e4';
